import * as THREE from "three";
import gsap from "gsap";

export default class Sky extends THREE.Object3D {
	constructor() {
		super();
        var skyVertexShader = `
		varying vec3 vWorldPosition;
	  
		void main() {
		  vec4 worldPosition = modelMatrix * vec4(position, 1.0);
		  vWorldPosition = worldPosition.xyz;
		  gl_Position = projectionMatrix * viewMatrix * worldPosition;
		}
	  `;
	  
        // Fragment shader
        const skyFragmentShader = `
            uniform vec3 topColor;
            uniform vec3 bottomColor;
            uniform float offset;
            uniform float exponent;
            varying vec3 vWorldPosition;
        
            void main() {
            float h = normalize(vWorldPosition + offset).y;
            gl_FragColor = vec4(mix(bottomColor, topColor, pow(max(0.0, h), exponent)), 1.0);
            }
        `;

        this.skyMaterial = new THREE.ShaderMaterial({
            uniforms: {
                topColor: { value: new THREE.Color( 0x0077ff) },
                bottomColor: { value: new THREE.Color(0xffffff) },
                offset: { value: 2},
                exponent: { value: 0.6 }
            },
            vertexShader: skyVertexShader,
            fragmentShader: skyFragmentShader,
            side: THREE.BackSide
        });
        const skyGeometry = new THREE.SphereGeometry(14, 32, 15);
        const sky = new THREE.Mesh(skyGeometry, this.skyMaterial);
      
        sky.position.set(0, 0, 0)
        this.add(sky)
	}

    updateSkyColor(topColor, bottomColor) {
        gsap.to( this.skyMaterial.uniforms.topColor.value, {
            duration: 3,
            ease: "Power1.easeOut",
            r: topColor.r,
            g: topColor.g,
            b: topColor.b,
        });

        gsap.to( this.skyMaterial.uniforms.bottomColor.value, {
            duration: 3,
            ease: "Power1.easeOut",
            r: bottomColor.r,
            g: bottomColor.g,
            b: bottomColor.b,
        });
    }
}